export default import.meta.env.VITE_GIT_REVISION;
